import DemoAvatar from "./DemoAvatar";
import { resolveDemoIcon } from "../icons/defaultIcons";
import type { InboxDemoIcons } from "../data/types";

type TransferNoticeProps = {
  operatorName: string;
  operatorAvatar?: string;
  time?: string;
  icons: InboxDemoIcons;
};

export default function TransferNotice({
  operatorName,
  operatorAvatar,
  time,
  icons,
}: TransferNoticeProps) {
  return (
    <div className="flex w-full flex-col items-center gap-2 text-[12px] leading-4 text-default-400">
      <p className="flex items-center justify-center gap-1">
        <span className="inline-flex size-3 items-center justify-center">
          {resolveDemoIcon(icons, "circleUser")}
        </span>
        <span>已转接到人工客服{time ? ` · ${time}` : ""}</span>
      </p>
      <DemoAvatar name={operatorName} size="sm" src={operatorAvatar} />
      <p>{operatorName} 已接管此会话</p>
    </div>
  );
}
